<template>
  <div class="wrapper">
    <input
      ref="input"
      type="text"
      class="form-control"
      :tabindex="tabindex"
      :maxlength="maxlength"
      :placeholder="placeholder"
      v-model="model"
      v-on:paste="onPaste"
      v-on:keydown="onKeyDown"
      v-on:keypress="onKeypress"
      v-on:keyup="onKeyup"
    />
  </div>
</template>

<script>
const LEFT = 37;
const RIGHT = 39;
const TAB = 9;

export default {
  name: 'InputComponent',
  props: {
    placeholder: String,
    maxlength: Number,
    maxdecimal: Number,
    value: String,
  },
  created() {
    this.tabindex = new Date().getTime();
  },
  data() {
    return {
      regex: /^\d+\.{0,1}\d*$/,
      cursorIndex: 0,
      tabindex: 0,
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    onPaste(event) {
      let text = (event.clipboardData || window.clipboardData).getData('text');
      if (!this.isDigitOrDot(text)) {
        return event.preventDefault();
      }

      if (this.model) {
        if (this.hasDot(this.model) && this.hasDot(text)) {
          return event.preventDefault();
        }

        if (!this.isWithinDecimalLength(this.model)) {
          this.model = this.model.slice(0, this.model.indexOf('.') + this.maxdecimal + 1);
        }
      }
    },
    onKeyDown(event) {
      if (this.model) {
        if (this.hasDot(this.model) && event.key == '.') {
          return event.preventDefault();
        }
      }
    },
    onKeypress(event) {
      switch (event.keyCode) {
        case LEFT:
        case RIGHT:
        case TAB:
        case 8:
        case 46:
          return;
        default:
          if (event.ctrlKey || event.metaKey) {
            return;
          }

          if (!this.isDigitOrDot(event.key)) {
            return event.preventDefault();
          }
      }
    },
    onKeyup(event) {
      if (!this.isWithinDecimalLength(this.model)) {
        this.model = this.model.slice(0, this.model.indexOf('.') + this.maxdecimal + 1);
      }
    },
    hasDot(value) {
      if (value.indexOf('.') == -1) {
        return false;
      }
      return true;
    },
    isDigitOrDot(value) {
      const regex = /(\d)|(\.)/;
      let boolean = regex.test(value);
      return boolean;
    },
    isDotOnLast(value) {
      let pos = value.indexOf('.');
      if (pos >= this.maxlength) {
        return false;
      }
      return true;
    },
    isDotOnFirst(value) {
      let pos = value.indexOf('.');
      if (pos == 1) {
        return true;
      }
      return false;
    },
    isValidPattern(value) {
      let boolean = this.regex.test(value);
      return boolean;
    },
    isWithinDecimalLength(value) {
      let arr = value.split('.');
      if (arr[1] != null && undefined != arr[1]) {
        if (arr[1].length > this.maxdecimal) {
          return false;
        }
      }
      return true;
    },
    clear() {
      this.model = '';
      this.$refs.input.value = this.model;
    },
  },
};
</script>

<style scoped>
input {
  position: relative;
  z-index: 2;
  height: 40px;
  padding-top: 9px;
  padding-bottom: 9px;
  border: 1px solid #4a6096;
  border-radius: 3px;
  outline: none;
  color: #e2edf9;
  background-color: #172735;
}

input:hover,
input:focus {
  background-color: #172735;
}
</style>
